import React from 'react';
import { Route } from 'react-router';

import AuthScreen from 'ggApp/shared/screens/Auth';

const AuthRoutes = <Route path="auth" component={AuthScreen} />;

export default AuthRoutes;
